import { Component, OnInit } from '@angular/core';
import { GlobalUtilsService } from '../global-utils.service';

@Component({
  selector: 'app-contact-section',
  templateUrl: './contact-section.component.html',
  styleUrls: ['./contact-section.component.scss']
})
export class ContactSectionComponent {
  constructor(public globalUtilsService: GlobalUtilsService) {}
}
